import {
  OrganizationErrors,
  OrganizationErrorExtensions,
} from './organizations';
import { PaidAccountErrors, PaidAccountErrorExtensions } from './paidAccount';
import { PromoCodeErrors, PromoCodeErrorExtensions } from './promoCodes';
import { PromotionErrors, PromotionErrorExtensions } from './promotions';

enum UnknownErrorExtensions {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export const Errors = {
  ...OrganizationErrors,
  ...PaidAccountErrors,
  ...PromoCodeErrors,
  ...PromotionErrors,
} as const;

export const ErrorExtensions = {
  ...OrganizationErrorExtensions,
  ...PaidAccountErrorExtensions,
  ...PromoCodeErrorExtensions,
  ...PromotionErrorExtensions,
  ...UnknownErrorExtensions,
} as const;

export type ErrorType = keyof typeof Errors;
export type ErrorExtensionsType = keyof typeof ErrorExtensions;
export {
  OrganizationErrors,
  OrganizationErrorExtensions,
  PaidAccountErrors,
  PaidAccountErrorExtensions,
};
